import request from 'configuration/request';

export const userApi = {
  signIn: (creditnals) => {
    return request({
      url: '/login/',
      method: 'POST',
      data: creditnals,
    });
  },

  signUp: (creditnals) => {
    return request({
      url: '/register/',
      method: 'POST',
      data: creditnals,
    });
  },

  getPriceTypeList: () => {
    return request({
      url: '/price_type/list/',
      method: 'GET',
    });
  },

  getUserTypeList: () => {
    return request({
      url: '/user_type/list/',
      method: 'GET',
    });
  },

  setCashbox: (data) => {
    return request({
      url: '/current/user/',
      method: 'PATCH',
      data,
    });
  },

  getUserOption: () => {
    return request({
      url: 'current/user/option/',
      method: 'GET',
    });
  },

  setUserOption: (data) => {
    return request({
      url: 'current/user/option/',
      method: 'PATCH',
      data,
    });
  },

  setStock: (data) => {
    return request({
      url: '/current/user/',
      method: 'PATCH',
      data,
    });
  },

  activateUser: (userId) => {
    return request({
      url: `/user/${userId}/activate/`,
      method: 'GET',
    });
  },

  setOrg: (data) => {
    return request({
      url: '/current/user/',
      method: 'PATCH',
      data,
    });
  },

  messageSend: (data) => {
    return request({
      url: 'user/message_send/',
      method: 'POST',
      data,
    });
  },

  codeCheck: (data) => {
    return request({
      url: 'user/code_check/',
      method: 'POST',
      data,
    });
  },

  phoneCheck: (data) => {
    return request({
      url: 'user/phone_checker/',
      method: 'POST',
      data,
    });
  },

  passwordResetSMS: (data) => {
    return request({
      url: 'user/password_reset_sms/',
      method: 'POST',
      data,
    });
  },

  passwordReset: (data) => {
    return request({
      url: 'reset_password/',
      method: 'POST',
      data,
    });
  },

  passwordResetConfirm: (data) => {
    return request({
      url: 'reset_password/confirm/',
      method: 'POST',
      data,
    });
  },
};
